export default __webpack_public_path__ + "static/media/help.4df7b121.svg";